import * as Actions from './actions';

const addDeclaration = (state, { newDeclaration }) => {
  if (!newDeclaration) {
    return state;
  }

  const { customsItems } = state;
  return {
    ...state,
    customsItems: [...customsItems, newDeclaration],
  };
};

const removeDeclaration = (state, { declarationKey, generateDeclaration }) => {
  if (!declarationKey || !generateDeclaration) {
    return state;
  }

  const { customsItems } = state;
  const filteredCustomsItems = customsItems.filter((declaration) => declaration.declarationKey !== declarationKey);

  // Ensure customItems contains an empty customs declaration if last one was removed
  const updatedCustomsItems = filteredCustomsItems.length ? filteredCustomsItems : [generateDeclaration()];

  return {
    ...state,
    customsItems: updatedCustomsItems,
  };
};

const updateDeclaration = (state, { declarationKey, updatedPayload }) => {
  if (!declarationKey || !updatedPayload) {
    return state;
  }

  const { customsItems } = state;
  const itemToUpdate = customsItems.find((declaration) => declaration.declarationKey === declarationKey);
  if (!itemToUpdate) {
    return state;
  }

  const itemChanged = Object.keys(updatedPayload).some((key) => {
    if (key === 'unitPrice') {
      return (
        updatedPayload[key] &&
        Object.keys(updatedPayload[key]).some((unitKey) => itemToUpdate[key][unitKey] !== updatedPayload[key][unitKey])
      );
    }

    return itemToUpdate[key] !== updatedPayload[key];
  });

  if (!itemChanged) {
    return state;
  }

  const updatedCustomsItems = customsItems.map((declaration) => {
    if (declaration.declarationKey === declarationKey) {
      return {
        ...declaration,
        ...updatedPayload,
      };
    }

    return declaration;
  });
  return {
    ...state,
    customsItems: updatedCustomsItems,
  };
};

const updateContentType = (state, { contentType }) => {
  if (state.content === contentType) {
    return state;
  }

  return {
    ...state,
    content: contentType,
  };
};

const updateDutiesPaid = (state, { dutiesPaid }) => {
  if (state.dutiesPaid === dutiesPaid) {
    return state;
  }

  return {
    ...state,
    dutiesPaid,
  };
};

const updatePostagePaid = (state, { postagePaid }) => {
  if (state.postagePaid === postagePaid) {
    return state;
  }

  return {
    ...state,
    postagePaid,
  };
};

const updateNonDelivery = (state, { nonDelivery }) => {
  if (state.nonDelivery === nonDelivery) {
    return state;
  }

  return {
    ...state,
    nonDelivery,
  };
};

const updateItnOrExemption = (state, { exemptionCodeOrITN }) => {
  if (state.exemptionCodeOrITN === exemptionCodeOrITN) {
    return state;
  }

  return {
    ...state,
    exemptionCodeOrITN,
  };
};

const updateExportDeclarationNumber = (state, { exportDeclarationNumber }) => {
  if (state.exportDeclarationNumber === exportDeclarationNumber) {
    return state;
  }

  return {
    ...state,
    exportDeclarationNumber,
  };
};

const updateInvoiceNumber = (state, { invoiceNumber }) => {
  if (state.invoiceNumber === invoiceNumber) {
    return state;
  }

  return {
    ...state,
    invoiceNumber,
  };
};

const updateImporterOfRecord = (state, { importerOfRecord }) => {
  if (state.importerOfRecord?.id === importerOfRecord.id) {
    return state;
  }

  return {
    ...state,
    importerOfRecord,
  };
};

const customsReducer = (state, action) => {
  if (!state || !state.customsItems) {
    throw new Error('Trying to update invalid customs state');
  }

  switch (action.type) {
    case Actions.ADD_DECLARATION:
      return addDeclaration(state, action.payload);
    case Actions.REMOVE_DECLARATION:
      return removeDeclaration(state, action.payload);
    case Actions.UPDATE_DECLARATION:
      return updateDeclaration(state, action.payload);
    case Actions.UPDATE_CONTENT_TYPE:
      return updateContentType(state, action.payload);
    case Actions.UPDATE_DUTIES_PAID:
      return updateDutiesPaid(state, action.payload);
    case Actions.UPDATE_POSTAGE_PAID:
      return updatePostagePaid(state, action.payload);
    case Actions.UPDATE_NON_DELIVERY:
      return updateNonDelivery(state, action.payload);
    case Actions.UPDATE_ITN_OR_EXEMPTION:
      return updateItnOrExemption(state, action.payload);
    case Actions.UPDATE_EXPORT_DECLARATION_NUMBER:
      return updateExportDeclarationNumber(state, action.payload);
    case Actions.UPDATE_INVOICE_NUMBER:
      return updateInvoiceNumber(state, action.payload);
    case Actions.UPDATE_IMPORTER_OF_RECORD:
      return updateImporterOfRecord(state, action.payload);
    default:
      return state;
  }
};

export default customsReducer;
